import React, { Component } from 'react';
import './teamgrid.css';

/*
 * Live render of a Team component: a responsive grid of members, each a
 * photo with name + title underneath. Data is filled via the admin forms
 * (no HTML editing). Reflows from several-across on desktop to 1-up on phones.
 */
export class TeamGrid extends Component {
    static displayName = TeamGrid.name;

    constructor(props) {
        super(props);
        this.state = {
            componentId: props.componentId,
            teamGrid: null,
            teamMembers: []
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    render() {
        let members = this.state.teamMembers.map((member, index) => (
            <div className='team-member' key={index}>
                {member.photoUrl ? <img src={member.photoUrl} alt={member.name ? member.name : 'Team member'} /> : null}
                <div className='team-name'>{member.name}</div>
                <div className='team-title'>{member.title}</div>
            </div>
        ));

        return (
            <div className='team-grid-component'>
                <div className='team-grid'>
                    {members}
                </div>
            </div>
        );
    }

    async getComponentData() {
        const response = await fetch('Components/GetTeamGrid?componentId=' + this.state.componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            teamGrid: data.teamGrid,
            teamMembers: data.teamMembers
        });
    }
}

export default TeamGrid;
